<template>
  <div class="bi-layout compair-layout">
    <h1 class="mb-8">Stellenanzeigen Vergleichen</h1>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2">
        <BiCompairBox :max-y="maxY" @max-y-updated="e => onMaxY('a', e)" />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <BiCompairBox :max-y="maxY" @max-y-updated="e => onMaxY('b', e)" />
      </div>
    </div>
  </div>
</template>

<script>
import BiCompairBox from "@/components/bi/BiCompairBox.vue";

export default {
  components: {
    BiCompairBox
  },
  data: () => ({
    maxValues: { a: 0, b: 0 }
  }),
  computed: {
    maxY() {
      return Math.max(this.maxValues["a"], this.maxValues["b"]);
    }
  },
  methods: {
    onMaxY(chartIdx, value) {
      this.maxValues[chartIdx] = value;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
